import React from 'react';

export default function bemComponent(baseClassName, displayName='Block') {
    class BemComponent extends React.Component {
        render() {
            const props = Object.assign({}, this.props);
            props.className = props.className || '';
            if (props.variations) {
                props.variations.forEach((v) => {
                    props.className += ` ${baseClassName}--${v}`;
            });
            }

            props.className = `${baseClassName} ${props.className}`;
            delete props.children;
            delete props.variations;

            return (
                <div { ...props }>
                    {this.props.children}
                </div>
            );
        }
    };

    BemComponent.displayName = displayName;

    return BemComponent;
}



// WEBPACK FOOTER //
// ./node_modules/@99designs/utils/app/bemComponent.jsx